var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("validation-observer", { ref: "formValidator" }, [
    _c("div", { staticClass: "my-5" }, [
      _c(
        "div",
        { staticClass: "mb-5" },
        [
          _c("section-title", {
            attrs: { "has-line": true, title: "Información del Contrato" }
          }),
          _c("div", { staticClass: "row ml-2" }, [
            _vm.model.id
              ? _c("div", { staticClass: "col-md-1" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "color-secondary-6 font-14 font-weight-normal"
                    },
                    [_vm._v(" Año Fiscal: ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "color-black font-16 font-weight-normal pt-1"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.fiscalYearDescription ||
                              _vm.currentFiscalYearDescription ||
                              "-"
                          ) +
                          " "
                      )
                    ]
                  )
                ])
              : _vm._e(),
            _c("div", { staticClass: "col-md-3 pl-4" }, [
              !_vm.IsReadOnly
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "color-secondary-6 font-14 font-weight-normal"
                      },
                      [_vm._v(" Fecha de Vigencia: ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center pt-1" },
                      [
                        _c("validation-provider", {
                          staticClass: "mr-2",
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-date-picker", {
                                      staticClass:
                                        "custom-date-picker__extended",
                                      attrs: {
                                        "custom-error-msg":
                                          _vm.errorMsgs.startDate,
                                        error: errors[0],
                                        "min-date": _vm.minFromDate,
                                        placeholder: "DD/MM/YYYY"
                                      },
                                      on: { input: _vm.dateHandler },
                                      model: {
                                        value: _vm.model.effectiveFromDate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "effectiveFromDate",
                                            $$v
                                          )
                                        },
                                        expression: "model.effectiveFromDate"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1351257727
                          )
                        }),
                        _c("span", { staticClass: "mx-1 font-weight-bold" }, [
                          _vm._v("-")
                        ]),
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-date-picker", {
                                      staticClass:
                                        "custom-date-picker__extended",
                                      attrs: {
                                        "custom-error-msg":
                                          _vm.errorMsgs.endDate,
                                        error: errors[0],
                                        "max-date": _vm.maxDate,
                                        "min-date": _vm.minToDate,
                                        placeholder: "DD/MM/YYYY"
                                      },
                                      on: { input: _vm.dateHandler },
                                      model: {
                                        value: _vm.model.effectiveToDate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "effectiveToDate",
                                            $$v
                                          )
                                        },
                                        expression: "model.effectiveToDate"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3251110603
                          )
                        })
                      ],
                      1
                    )
                  ])
                : _vm.editingVigency
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "color-secondary-6 font-14 font-weight-normal"
                      },
                      [_vm._v(" Fecha de Vigencia: ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center pt-1" },
                      [
                        _c(
                          "div",
                          { staticClass: "mr-1" },
                          [
                            _c("custom-date-picker", {
                              staticClass: "custom-date-picker__extended",
                              attrs: { placeholder: "DD/MM/YYYY" },
                              model: {
                                value: _vm.vigencyDraft.effectiveFromDate,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.vigencyDraft,
                                    "effectiveFromDate",
                                    $$v
                                  )
                                },
                                expression: "vigencyDraft.effectiveFromDate"
                              }
                            })
                          ],
                          1
                        ),
                        _c("span", { staticClass: "mx-1 font-weight-bold" }, [
                          _vm._v("-")
                        ]),
                        _c(
                          "div",
                          { staticClass: "mr-2" },
                          [
                            _c("custom-date-picker", {
                              staticClass: "custom-date-picker__extended",
                              attrs: { placeholder: "DD/MM/YYYY" },
                              model: {
                                value: _vm.vigencyDraft.effectiveToDate,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.vigencyDraft,
                                    "effectiveToDate",
                                    $$v
                                  )
                                },
                                expression: "vigencyDraft.effectiveToDate"
                              }
                            })
                          ],
                          1
                        ),
                        _c("action-button", {
                          staticClass: "mr-2 number-edit-btn",
                          attrs: {
                            i: "fas fa-save",
                            title: "Guardar",
                            variant: "outline-success"
                          },
                          on: { click: _vm.updateContractVigency }
                        }),
                        _c("action-button", {
                          staticClass: "number-edit-btn",
                          attrs: {
                            i: "fas fa-times",
                            title: "Cancelar",
                            variant: "outline-secondary"
                          },
                          on: { click: _vm.onCancelVigency }
                        })
                      ],
                      1
                    )
                  ])
                : _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "color-secondary-6 font-14 font-weight-normal"
                      },
                      [_vm._v(" Fecha de Vigencia: ")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "color-black font-16 font-weight-normal pt-1"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("date")(_vm.model.effectiveFromDate)
                            ) +
                            " - " +
                            _vm._s(_vm._f("date")(_vm.model.effectiveToDate)) +
                            " "
                        ),
                        _vm.canToggleVigency
                          ? _c("em", {
                              staticClass: "fas fa-edit color-primary-1 ml-1",
                              staticStyle: { cursor: "pointer" },
                              attrs: { title: "Editar vigencia" },
                              on: { click: _vm.onToggleVigency }
                            })
                          : _vm._e()
                      ]
                    )
                  ])
            ]),
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    !_vm.IsReadOnly ||
                    (_vm.IsReadOnly && _vm.canEditProposalNumber)
                      ? _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        id: "contractNumber",
                                        "custom-error-msg":
                                          _vm.errorMsgs.contract,
                                        error: errors[0],
                                        label: "Número de Contrato:",
                                        "label-class": "data-name",
                                        name: "contractNumber"
                                      },
                                      model: {
                                        value: _vm.model.contractNumber,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "contractNumber",
                                            $$v
                                          )
                                        },
                                        expression: "model.contractNumber"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3283815510
                          )
                        })
                      : _c("div", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "color-secondary-6 font-14 font-weight-normal"
                            },
                            [_vm._v(" Número de Contrato: ")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "color-black font-16 font-weight-normal pt-1"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("empty")(_vm.model.contractNumber)
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ])
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    !_vm.IsReadOnly ||
                    (_vm.IsReadOnly && _vm.canEditProposalNumber)
                      ? _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        id: "contractNumberFinancialSystem",
                                        "custom-error-msg":
                                          _vm.errorMsgs
                                            .contractNumberFinancialSystem,
                                        error: errors[0],
                                        label:
                                          "Num. de Contrato de Sistema Financiero:",
                                        "label-class": "data-name",
                                        name: "contractNumberFinancialSystem"
                                      },
                                      model: {
                                        value:
                                          _vm.model
                                            .contractNumberFinancialSystem,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "contractNumberFinancialSystem",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "model.contractNumberFinancialSystem"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2025188069
                          )
                        })
                      : _c("div", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "color-secondary-6 font-14 font-weight-normal"
                            },
                            [
                              _vm._v(
                                " Número de Contrato de Sistema Financiero: "
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "color-black font-16 font-weight-normal pt-1"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("empty")(
                                      _vm.model.contractNumberFinancialSystem
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ])
                  ],
                  1
                ),
                !_vm.IsReadOnly || (_vm.IsReadOnly && _vm.model.isDirectPayment)
                  ? _c("div", { staticClass: "col-4" }, [
                      _c("div", [
                        _c("span", { staticClass: "data-label" }, [
                          _vm._v("Contrato específico para:")
                        ]),
                        _c("div", { staticClass: "row py-2" }, [
                          _c(
                            "div",
                            { staticClass: "col" },
                            [
                              _c("check-box", {
                                attrs: {
                                  disabled: _vm.IsReadOnly,
                                  text: "Pago Directo"
                                },
                                model: {
                                  value: _vm.model.isDirectPayment,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "isDirectPayment", $$v)
                                  },
                                  expression: "model.isDirectPayment"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm.IsReadOnly && _vm.canEditProposalNumber
                  ? _c("div", { staticClass: "col" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            position: "relative",
                            "padding-top": "2em",
                            right: "23px"
                          }
                        },
                        [
                          _c(
                            "action-button",
                            {
                              attrs: {
                                i: "fas fa-save",
                                variant: "outline-success"
                              },
                              on: { click: _vm.updateContractNumber }
                            },
                            [_vm._v(" Guardar ")]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ])
            ]),
            _c("div", { staticClass: "col-md-2" }, [
              _c(
                "div",
                { staticClass: "color-secondary-6 font-14 font-weight-normal" },
                [_vm._v(" Estatus: ")]
              ),
              _c(
                "div",
                { staticClass: "pt-2" },
                [
                  _c("status-badge", {
                    attrs: {
                      title:
                        _vm.model.isSignedFlag === true
                          ? "Firmado"
                          : "No firmado",
                      type: _vm.model.isSignedFlag === true ? "success" : "none"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _vm.showAmendmentRecomendation
        ? _c("div", [
            _c(
              "div",
              {
                staticClass:
                  "alert alert-danger-custom d-flex justify-content-between",
                staticStyle: { "font-weight": "bold" },
                attrs: { role: "alert" }
              },
              [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("span", { staticClass: "mr-3" }, [
                    _c("i", { staticClass: "fas fa-times-circle" })
                  ]),
                  _c("span", [
                    _vm._v(
                      " Debe seleccionar fechas fuera de la vigencia actual o enmendar el contrato en cuestión. El período de vigencia del mismo es: "
                    ),
                    _c("br"),
                    _vm._v(" Fecha de comienzo: "),
                    _c("span", { staticStyle: { "font-weight": "normal" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("date")(_vm.conflictContract.dateFrom)
                          ) +
                          "; "
                      )
                    ]),
                    _vm._v(" Fecha de finalización: "),
                    _c("span", { staticStyle: { "font-weight": "normal" } }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("date")(_vm.conflictContract.dateTo)) +
                          " "
                      )
                    ])
                  ])
                ]),
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _vm.conflictContract.isSigned &&
                  !_vm.conflictContract.isDirectPayment
                    ? _c(
                        "span",
                        {
                          staticClass: "redirect__action",
                          on: { click: _vm.onAmendmentRedirect }
                        },
                        [_c("u", [_vm._v("Enmendar Contrato")])]
                      )
                    : !_vm.conflictContract.isDirectPayment
                    ? _c(
                        "span",
                        {
                          staticClass: "redirect__action",
                          on: { click: _vm.onEditRedirect }
                        },
                        [_c("u", [_vm._v("Modificar Contrato")])]
                      )
                    : _vm._e()
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm.showInformationSection
        ? _c(
            "div",
            [
              _vm.hasViewDocumentPermission
                ? _c(
                    "div",
                    { staticClass: "mb-5" },
                    [
                      _c("section-title", {
                        attrs: {
                          "has-line": true,
                          title: "Documento de Contrato"
                        }
                      }),
                      _c("documents", {
                        attrs: {
                          "auto-upload": !!_vm.model.id,
                          "available-document-types":
                            _vm.availableDocumentTypes,
                          "can-remove":
                            !_vm.model.isSignedFlag || _vm.canRemoveDocument,
                          disabled:
                            !_vm.hasViewDocumentPermission || _vm.readOnly,
                          "on-download": _vm.onDownload
                        },
                        on: {
                          onRemove: _vm.onRemoveDocuments,
                          onUpload: _vm.uploadDocument
                        },
                        model: {
                          value: _vm.model.documents,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "documents", $$v)
                          },
                          expression: "model.documents"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showSeparationFunds
                ? _c(
                    "div",
                    { staticClass: "mb-5" },
                    [
                      _c("separation-of-funds", {
                        ref: "separationOfFunds",
                        attrs: {
                          "contract-id": Number(_vm.model.id),
                          "fiscal-year-id":
                            _vm.currentFiscalYearId || _vm.data.fiscalYearId,
                          "is-contract-signed": _vm.model.isSignedFlag,
                          "own-save": "",
                          "read-only": true
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("SIFDEInformation", {
                attrs: {
                  "academic-year": _vm.fiscalYearDescription,
                  "company-id-value": _vm.companyIdValue,
                  "contract-number": _vm.contractNumberFinancialSystem
                }
              }),
              _vm.model.id
                ? _c("service-information-list", {
                    attrs: {
                      "add-enabled":
                        !_vm.IsReadOnly ||
                        _vm.userHasPermissions(
                          "provider.contract.services.add"
                        ),
                      "company-id": _vm.companyIdValue,
                      "contract-id": _vm.model.id,
                      "delete-enabled":
                        !_vm.IsReadOnly &&
                        _vm.userHasPermissions(
                          "provider.contract.services.delete"
                        ),
                      disabled: _vm.IsReadOnly,
                      "edit-enabled": _vm.canEditService,
                      "on-deleting": _vm.onServiceDeleting,
                      "on-saving": _vm.onServiceSaving,
                      value: _vm.model.services
                    }
                  })
                : _vm._e(),
              _vm.showBtnSave && !_vm.IsReadOnly
                ? _c("fixed-bottom-save-button", {
                    attrs: { offset: 150 },
                    on: { click: _vm.save }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }